import './search-bar.scss';
import '../../search-input-field.scss';
import React from 'react';
import {SearchQueryFieldsSelection} from './searchQueryFieldsSelection';
import {SearchSources} from './searchSources';
import {SearchInputField} from './searchInputField';

type SearchBarInputProps = {
    readonly placeholder: string;
    // Using string object here to ensure calling setCurrentValue() even when query is the same.
    // Case: searching for 'clariant', then entering 'schülke' without pressing enter. Then switching search sources to bookmarks
    // -> the search field should automatically change to 'clariant'
    // eslint-disable-next-line @typescript-eslint/ban-types
    readonly initialValue: String;
    readonly onSubmit: (searchQuery: string) => void;
};

export const SearchBar = React.memo((props: SearchBarInputProps) => {
    return (
        <div className="hibu-search-bar">
            <SearchSources/>
            <SearchQueryFieldsSelection/>
            <SearchInputField placeholder={props.placeholder} initialValue={props.initialValue}
                              onSubmit={props.onSubmit}/>
        </div>
    );
});
